export default "__VITE_ASSET__ni$O60Ys__"